import { render, staticRenderFns } from "./PublicGame.vue?vue&type=template&id=003b0ac5&"
import script from "./PublicGame.vue?vue&type=script&lang=js&"
export * from "./PublicGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports